module.exports = __webpack_public_path__ + "img/header-composant-2@2x.fc5f5e92.png";